import axiosPublic from '@/common/interceptors/axios.PublicInterceptor';

const getScanSelfServiceAutosuggestions = ({
  // eslint-disable-next-line no-unused-vars
  queryKey: [endpoint, term],
}) => {
  const params = {
    search_term: term,
    limit: 5,
  };

  return axiosPublic
    .get(`/api/self-scan-service/${endpoint}`, { params })
    .then((res) => res.data);
};

export default getScanSelfServiceAutosuggestions;
